module.exports = __webpack_public_path__ + "img/about-desc-sm.3d7f3aee.png";